import Axios from "axios";import Qs from "qs";
import {prefix as PREFIX, api as BASE_URL} from "../../config";
// import {vueInstance} from "../main"

const axios = Axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    transformRequest: function (data) {
        return Qs.stringify(data)
    }
})
const jsonAxios = Axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
})


/**
 * 用来创建普通请求方法
 * @param type
 * @param api
 * @param useJson
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, useJson, cancelToken) {

    api = PREFIX + api
    let axiosObj = axios

    if (useJson) {
        axiosObj = jsonAxios
    }



    return function (data) {
        switch (type) {
            case 'get':
                return axiosObj.get(api, { params: data, cancelToken });
            case 'post':
                return axiosObj.post(api, data, { cancelToken });
            case 'put':
                return axiosObj.put(api, data, { cancelToken });
            case 'delete':
                return axiosObj.delete(api, { params: data, cancelToken });
        }
    }
}
function setToken(config) {
	let token = window.sessionStorage.getItem("token")
	config.headers['Authorization'] = 'Bearer ' +token
	return config;
}



[jsonAxios, axios].forEach(obj => {
	obj.interceptors.response.use(function (response) {
		return response
	}, function (error) {
		if(error.response && error.response.status === 401){
	console.log(11111111111111111111111)

		}
		return error;
	});

	obj.interceptors.request.use(setToken, e => {
		console.log(e)
	})
});
// //拦截器的配置
// //请求头拦截
// axios.interceptors.request.use(config => {
//     console.log(config)
//     // 在发送请求之前做些什么

//     if (window.localStorage.getItem("token")) {
//         config.headers.common["token"] = window.localStorage.getItem("token")
//         return config;
//     }

// }, error => {
//     // 对请求错误做些什么
//     return Promise.reject(error);
// });


// // //响应头拦截
// axios.interceptors.response.use(response => {
//     return response;
// }, error => {
//     console.log(error)
//     if (error.response) {
//         switch (error.response.status) {
//             // 返回401，清除token信息并跳转到登录页面
//             case 404:
//                 alert("跳到错误页面");
//                 break;
//             case 500:
//                 alert("接口调用错误")
//                 break;
//         }
//         // 返回接口返回的错误信息
//         return Promise.reject(error.response.data);
//     }
// });

export default Axios;